import { useQuery } from 'react-query';

import { getLearningActivity } from '@/modules';

export const useGetLearningActivity = (classData) => {
    const { classroomId, providerArn, learningActivityID } = classData?.classroom ?? {};
    return useQuery(
        [classroomId, providerArn, learningActivityID, 'getLearningActivity'],
        () => getLearningActivity(classroomId, providerArn, learningActivityID),
        {
            refetchOnWindowFocus: false,
            enabled: !!learningActivityID,
        },
    );
};
